<script>
export default {
  data() {
    return {
      list: [
        {
          title: '加入零壹',
          name: 'elite-join',
        },
        {
          title: '成長在零壹',
          name: 'elite-grow',
        },
        {
          title: '生活在零壹',
          name: 'elite-live',
        },
      ],
    }
  },
}
</script>
<template>
  <BaseLayout :menu-list="list" :img="require('@assets/images/elite/banner@2.png')" custom-class="isStyleWhite">
    <slot />
  </BaseLayout>
</template>
<style lang="scss" module>
</style>
